// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36uEk","col":"styles_col__2IZ32"};